import React from "react";
import { Button, Modal } from "antd";
import { CloseIcon } from "@/components/icons";
import { useModalStore } from "@/hooks/useModalStore";
import { usePaymentStore } from "@/hooks/usePaymentStore";
import { s3ImageLink } from "@/utils/links";
import { useTranslation } from "react-i18next";

interface Props {}

const PayMethodModal: React.FC<Props> = () => {
  const { t } = useTranslation();
  const {
    showPaymethodModal,
    setPaymethodModal,
    setShowModalPaymentBoundCard,
    setShowChargeModal,
  } = useModalStore();
  const { reQueryWalletData } = usePaymentStore();

  return (
    <Modal
      closable={false}
      footer={null}
      open={showPaymethodModal}
      styles={{
        content: {
          padding: 0,
          borderRadius: "24px",
          overflow: "hidden",
        },
      }}
      width={537}
    >
      <div className="w-full relative">
        <div className="w-full">
          <img src={`${s3ImageLink}paymethod-modal-banner.png`} alt="paymethod-modal-banner" />
        </div>
        <div className="px-[56px] pb-8">
          <div className="w-full inline-flex flex-col justify-start items-center gap-2 mt-8">
            <div className="self-stretch text-center justify-start text-orange-600 text-base font-medium ">
              {t("components.paymethodModal.limitedTimeOffer")}
            </div>
            <div className="self-stretch text-center justify-start text-neutral-900 text-4xl font-semibold ">
              {t("components.paymethodModal.depositFundsNowAndGetExtraAdCredits")}
            </div>
          </div>
          <Button
            className="w-full black-button mt-8 rounded-[20px]"
            size="large"
            onClick={() => {
              reQueryWalletData();
              setPaymethodModal(false);
              setShowChargeModal(true);
            }}
          >
            {t("components.paymethodModal.depositFundsNow")}
          </Button>
          <Button
            type="text"
            className="mt-3 w-full"
            onClick={() => {
              setPaymethodModal(false);
              setShowModalPaymentBoundCard(true);
            }}
          >
            {t("components.paymethodModal.addACard")}
          </Button>
        </div>
        <div
          className="absolute right-4 top-4 cursor-pointer"
          onClick={() => {
            setPaymethodModal(false);
          }}
        >
          <CloseIcon className="text-white w-[24px] h-[24px]" />
        </div>
      </div>
    </Modal>
  );
};

export default PayMethodModal;
